import {toast} from "react-toastify";

const t = (message) => toast(message)
export default {
    error(message) {
        toast.error(message)
    }, success(message) {
        toast.success(message)
    }, default(message) {
        toast(message)
    }
}
